module.exports = {"scan":"请用手机扫描二维码","download":"下载","downloadDes":"App for iOS and Android","title":"Septekon APP Download"}


//////////////////
// WEBPACK FOOTER
// ./src/common/i18n/app-zh.json
// module id = 0t32
// module chunks = 2